import React from "react";
import CampaignGroups from "../../client_config/ppc_config/CampaignGroups"

export default function Video(props) {
  
  const videoCampaignGroups = props.campaignGroups.video
  const allCampaignGroups = props.campaignGroups

  return (
   <div style={{backgroundColor:"#F5F5F5"}}>

    <CampaignGroups {...props} platformType="Video" campaignGroups={videoCampaignGroups} allCampaignGroups={allCampaignGroups} setCampaignGroups={props.setCampaignGroups} onboarding />
   </div>
  
  );
}